import { render } from "./Home2023.vue?vue&type=template&id=4aeff51b"
import script from "./Home2023.js?vue&type=script&lang=js"
export * from "./Home2023.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__